import { API } from "../store"
import handleCatch from "../lib/catch"

export const createClientInvoice = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/create-client-invoice`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getStripeClient = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/create-client-paymentintent`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
